"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HambergerMenu = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
const react_1 = require("@emotion/react");
const HambergerMenu = ({ navigationState, setLayoutContextState }) => {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: styles, className: (0, clsx_1.default)({
            mobile: navigationState !== "desktop",
            open: navigationState === "mobileViewOpen",
        }), onClick: () => setLayoutContextState((_a) => {
            var { navigationState } = _a, rest = __rest(_a, ["navigationState"]);
            return (Object.assign(Object.assign({}, rest), { navigationState: navigationState === "mobileViewOpen" ? "mobileViewClosed" : "mobileViewOpen" }));
        }) }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, clsx_1.default)("hamberger-container", { open: navigationState === "mobileViewOpen" }) }, { children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", {})] })) })));
};
exports.HambergerMenu = HambergerMenu;
const styles = (0, react_1.css) `
  top: 1.25rem;
  right: 1.25rem;
  width: 2.4rem;
  height: 2.4rem;
  position: fixed;
  transition: all 300ms ease-in, visibility 0ms 800ms;
  opacity: 0;
  visibility: hidden;
  z-index: 4;

  & * {
    margin: 0;
    padding: 0;
  }

  &.mobile {
    opacity: 1;
    visibility: visible;
    transition: all 300ms ease-in, visibility 0ms;
  }

  .hamberger-container {
    width: 2.4rem;
    height: 2.4rem;
    position: relative;
    cursor: pointer;

    span {
      left: 0;
      width: 2.4rem;
      height: 0.2rem;
      display: block;
      position: absolute;
      transform: rotate(0deg);
      transition: all 280ms 60ms ease-out;
      background-color: black;
    }

    span:nth-of-type(1) {
      top: 0.42rem;
    }
    span:nth-of-type(2),
    span:nth-of-type(3) {
      top: 1.1rem;
    }
    span:nth-of-type(4) {
      top: 1.8rem;
    }

    &:hover span {
      background-color: #313a46;
    }
    &.open {
      span {
        background-color: #fff;
      }
      span:nth-of-type(1),
      span:nth-of-type(4) {
        top: 1.1rem;
        width: 0;
        left: 50%;
      }
      span:nth-of-type(2) {
        transform: rotate(45deg);
      }
      span:nth-of-type(3) {
        transform: rotate(-45deg);
      }
    }
  }
`;
